<template>
    <div>
        <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
        <iotInsightsTab />
        <Filter />
         <div class="container-fluid" style="background-color: #e7e7e7;">
    <div class="row" >
    

      <div class="col-12 mb-3">
        <div class="box" style="height: 50vh;">
          <FlowMgmt />
        </div>
      </div>

      <div class="col-12 ">
        <div class="box" style=" height: 55vh;">
         <SensorDetails />
        </div>
      </div>
    </div>
  </div>

    </div>

</template>
<script>
import Header from '@/components/Header.vue';
import Filter from '@/components/Filter.vue';
import iotInsightsTab from '@/components/iot-insights-tab.vue';
import FlowMgmt from './flow-mgmt.vue';
import SensorDetails from './sensor-details.vue';
export default {
    name: "iot",
    components: {
        Header,
        Filter,
        iotInsightsTab,
        FlowMgmt,
        SensorDetails
    },
    data() {
        return {
            breadcrumsfirst: "Dashboard",
            breadcrumslast: "IoT Insights",
        }
    }
}
</script>
<style>

</style>